import React from 'react'
import { Alert, Button, Typography } from '@mui/material'
import _ from 'lodash'
import MUIModal from '../../../../common/MUIModal'
import MaterialTable from '../../../../common/MaterialTable'
import { getDDMMYYYYHHmmToIST } from '../../../../helpers/UtilityHelper'

export default function MissingPickupDateAlert({ shipments = [], allCouriers = [] }) {
    const [open, setOpen] = React.useState(false)

    if (!shipments.length) return null

    const courierMap = _.keyBy(allCouriers, 'id')

    const columns = [
        { label: 'AWB Number', value: 'awbNumber', align: 'left' },
        {
            label: 'Courier',
            align: 'left',
            value: (row) => {
                const c = courierMap[row.courier]
                return c ? c.parent || c.name : row.courier || '-'
            },
        },
        { label: 'Status', value: 'orderStatus', align: 'left' },
        { label: 'Zone', value: 'merchantZone', align: 'left' },
        { label: 'Pickup Pincode', value: 'pickupPincode', align: 'left' },
        { label: 'Drop Pincode', value: 'dropPincode', align: 'left' },
        {
            label: 'AWB Date',
            align: 'left',
            value: (row) => row.awbRegisteredDate ? getDDMMYYYYHHmmToIST(row.awbRegisteredDate).replace(',', '') : '-',
        },
        {
            label: 'First Delivery Attempt',
            align: 'left',
            value: (row) => {
                const ts = row.firstDeliveryAttemptTimestamp
                return ts ? getDDMMYYYYHHmmToIST(ts).replace(',', '') : '-'
            },
        },
        {
            label: 'Estimated Pickup Date',
            align: 'left',
            value: (row) => {
                if (!row.estimatedPickupDate) return 'MISSING'
                return getDDMMYYYYHHmmToIST(row.estimatedPickupDate).replace(',', '')
            },
        },
    ]

    return (
        <>
            <Alert
                severity='warning'
                sx={{ mt: 1 }}
                action={
                    <Button size='small' color='warning' variant='outlined' onClick={() => setOpen(true)}>
                        Click to view
                    </Button>
                }
            >
                <Typography variant='body2' component='span'>
                    <b>{shipments.length} shipments</b> are excluded — Estimated Pickup Date is missing or
                    invalid (pickup after attempt).
                </Typography>
            </Alert>
            <MUIModal
                open={open}
                handleClose={() => setOpen(false)}
                title={`Excluded Shipments — Pickup Date Missing / Invalid (${shipments.length})`}
                maxWidth='xl'
            >
                <MaterialTable
                    columns={columns}
                    rows={shipments}
                    fileName='MISSING_PICKUP_DATE_SHIPMENTS'
                    exportExcel={true}
                    itemsPerPage={25}
                    minWidth={900}
                />
            </MUIModal>
        </>
    )
}
